// extracted by mini-css-extract-plugin
export var QuoteComponent = "QuoteComponent-module--QuoteComponent--rurBK";
export var border = "QuoteComponent-module--border--quhrc";
export var content = "QuoteComponent-module--content--0XYZ5";
export var quote = "QuoteComponent-module--quote--qeZiI";
export var image = "QuoteComponent-module--image--b9Sop";
export var authorBlock = "QuoteComponent-module--authorBlock--HSlkf";
export var authorName = "QuoteComponent-module--authorName--JFlll";
export var authorTitle = "QuoteComponent-module--authorTitle--Qx8rd";
export var authorTexts = "QuoteComponent-module--authorTexts--9pSKz";